import { render, staticRenderFns } from "./mandates.vue?vue&type=template&id=50f9d185&scoped=true&"
import script from "./mandates.vue?vue&type=script&lang=js&"
export * from "./mandates.vue?vue&type=script&lang=js&"
import style0 from "./mandates.vue?vue&type=style&index=0&id=50f9d185&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9d185",
  null
  
)

export default component.exports